angular.module('qkr').controller('cases21Controller',
    ($scope, $rootScope, $uibModal, messageService, cases21Service, gettextCatalog, appConfig, familyInfo,
        beneficiaryCustomFields, $routeSegment) => {
    const vm = $scope;

    vm.orderProp = 'lastName'; // Default order
    vm.orderReverse = false;
    vm.query = '';
    vm.file = {
        selectedFile: ''
    };

    vm.yearWarningMessage = beneficiaryCustomFields.find(field => field.fieldName === 'Year') ?
        '' : `'${gettextCatalog.getString('Year')}' ${gettextCatalog.getString('is not configured Student Details')}`;

    vm.uploading = false;
    vm.latestUploadDate = 0;

    vm.cases21FamiliesDef = familyInfo.families
        .filter(family => family.familyNumber !== undefined)
        .map(cases21Service.addFilterKey);

    vm.cases21FamiliesUndef = familyInfo.families
        .filter(family => family.familyNumber === undefined)
        .map(family => Object.assign({}, family, {familyNumber: ''}))
        .map(cases21Service.addFilterKey);

    vm.totalUploadedFamilies = familyInfo.numUploadedFamilies;
    vm.totalUploadedChildren = familyInfo.numUploadedChildren;
    vm.latestUploadDate = familyInfo.lastUploadedDate;

    vm.init = function() {
        $rootScope.undefinedFamilyNumbers = countTotalUndefinedFamilyNumbers(vm.cases21FamiliesUndef);
    };

    vm.sortBy = function(colName) {
        if (vm.orderProp === colName) {
            vm.orderReverse = !vm.orderReverse;
        } else {
            vm.orderProp = colName;
            vm.orderReverse = false;
        }
    };

    vm.sortIcon = function(colName) {
        if (vm.orderProp === colName) {
            if (vm.orderReverse) {
                return 'glyphicon glyphicon-chevron-up';
            } else {
                return 'glyphicon glyphicon-chevron-down';
            }
        } else {
            return null;
        }
    };

    vm.invalidFamilyNumber = function(family) {
        return cases21Service.invalidFamilyNumber(family);
    };

    vm.updateFamilyNumber = function(family) {
        if (cases21Service.invalidFamilyNumber(family.familyNumber)) {
            messageService.error(gettextCatalog.getString('Family number must be more then 6 digits (or blank)'));
        } else {
            cases21Service.updateFamilyNumber(family)
                .then(() => {
                    if (family.multipleWarning) {
                        messageService.success(gettextCatalog.getString('Family number updated - full reload ' +
                            'required, please wait'));
                        reloadRoute();
                    } else {
                        messageService.success(gettextCatalog.getString('Family number updated'));
                        reloadRoute();
                    }
                }, () => {
                    messageService.error(gettextCatalog.getString('Update failed.'));
                });
        }
    };

    vm.hideFamilyNumber = function(family) {
        cases21Service.hideFamilyNumber(family)
            .then(() => {
                messageService.success(gettextCatalog.getString('Family number updated'));
                reloadRoute();

            }, () => {
                messageService.error(gettextCatalog.getString('Update failed.'));
            });
    };

    vm.unHideFamilyNumber = function(family) {
        cases21Service.unHideFamilyNumber(family)
            .then(() => {
                messageService.success(gettextCatalog.getString('Family number updated'));
                reloadRoute();
            }, () => {
                messageService.error(gettextCatalog.getString('Update failed.'));
            });
    };

    vm.uploadFile = function() {
        vm.file.selectedFile = angular.element('#cases21File')[0].files[0];

        if (!vm.file.selectedFile) {
            return;
        }

        vm.uploading = true;

        cases21Service.uploadFile(vm.file.selectedFile)
            .then(rs => {
                const uploadFileResponse = rs.data;
                if (uploadFileResponse.lastUploadedDate === vm.latestUploadDate) {
                    vm.uploadMessage = 'There were no records updated or created in the last file uploaded';
                }
                vm.uploading = false;
                messageService.success(gettextCatalog.getString('File uploaded successfully.'));
                reloadRoute();
            }, rs => {
                const data = rs.data;
                let errorMsg = gettextCatalog.getString('File uploaded failed. ');
                if (data && data.exception) {
                    errorMsg = errorMsg + ' (' + data.exception + ')';
                }
                messageService.error(errorMsg);
                vm.uploading = false;
            });
    };

    vm.unknownFamilyNumberConfig = function() {
        $uibModal.open({
            template: require('../templates/accountancy/cases21/unknownFamilyNumberEmailConfig.html'),
            controller: 'unknownFamilyNumberEmailConfigController',
            windowClass: 'fade modal-huge',
            backdrop: 'static',
            resolve: {
                data() {
                    return cases21Service.getUnknownFamilyNumberConfig();
                }
            }
        });
    };

    vm.deleteBeneficiaries = function(family) {
        let confMsg = gettextCatalog.getString('Are you sure you want to delete this family record?');
        if (family.beneficiaryIds.indexOf(',') === -1) {
            confMsg += gettextCatalog.getString('The child') + ' ' + family.childList + ' ' +
                gettextCatalog.getString('will be removed from the parents phone.');
        } else {
            confMsg += gettextCatalog.getString('The children') + ' ' + family.childList + ' ' +
                gettextCatalog.getString('will be removed from the parents phone.');
        }

        const modalInstance = createCommonDialogModalInstance(gettextCatalog.getString('Delete Family Record for') +
            family.lastName + ', ' + family.childList, gettextCatalog.getString('Delete'), confMsg, []);

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                cases21Service.deleteFamily(family).then(() => {
                    messageService.success(gettextCatalog.getString('Family deleted'));
                    reloadRoute();
                }, () => {
                    messageService.error(gettextCatalog.getString('Delete failed.'));
                });
            }
        });
    };

    function countTotalUndefinedFamilyNumbers(undefinedFamilyNumbers) {
    	return undefinedFamilyNumbers.filter(f => !f.hidden).length;
    }

    function createCommonDialogModalInstance(title, confirmButtonName, confirmMsg, multiMsgArray) {
        return $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return confirmButtonName;
                },
                confirmMsg() {
                    return confirmMsg;
                },
                multiMsgArray() {
                    return multiMsgArray;
                }
            }
        });
    }

    function reloadRoute() {
        $routeSegment.chain[0].reload();
    }
});

angular.module('qkr').controller('unknownFamilyNumberEmailConfigController',
    ($scope, $uibModalInstance, messageService, cases21Service, reportService, data, gettextCatalog) => {
    const vm = $scope;

    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();
    vm.form = data;

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    vm.validate = function() {
        vm.errors = null;
        let valid = true;
        const errors = {};

        if (!(/^[A-Za-z0-9._%+'-]*[A-Za-z0-9]+@[A-Za-z0-9.'-]+\.[A-Za-z]{2,4}$/.test(vm.form.email))) {
            errors.email = gettextCatalog.getString('A valid email must be entered');
            valid = false;
        }

        vm.errors = errors;

        return valid;
    };

    vm.save = function() {
        if (!vm.validate()) {
            return;
        }
        cases21Service.saveUnknownFamilyNumberEmailConfig(vm.form).then(() => {
            $uibModalInstance.close('Saved');
            messageService.success(gettextCatalog.getString('Email details saved.'));
        }).error(() => {
            messageService.error(gettextCatalog.getString('Update failed'));
        });
    };

});



// WEBPACK FOOTER //
// ./src/controllers/cases21.controller.js